import { concantQuery } from '@/utils/concatQuery'
import api from './api'
import EventEmitter from '@/utils/EventEmitter'

export const AuctionEventEmitter = new EventEmitter()

const wsEvents = {
  CAR_MANAGER_UPDATE_CAR: 'CAR_MANAGER_UPDATE_CAR',
  CAR_MANAGER_NEW_BID: 'CAR_MANAGER_NEW_BID',
  AUCTION_MANAGER_NEW_CAR: 'AUCTION_MANAGER_NEW_CAR',
  AUCTION_MANAGER_UPDATE_CAR: 'AUCTION_MANAGER_UPDATE_CAR',
  CAR_COMMENTS: 'CAR_COMMENTS',
}

/**
 * Listen websocket event
 * Example: wsListeners[wsEvents.SOME_EVENT](callback)
*/
const wsListeners = (() => {
  const listeners = Object.keys(wsEvents)
    .reduce((acc, eventName) => {
      acc[eventName] = (fn) => AuctionEventEmitter.on(eventName, fn)
      return acc
    }, {})

  return listeners
})()

const wrapAction = (action) => {
  if (!wsActions.socket) {
    AuctionEventEmitter.on('connect', action)
  } else {
    action()
  }
}

const wsActions = {
  socket: null,
  ACTION_JOIN_TO_CAR_MANAGER: () => {
    wrapAction(() => wsActions.socket.emit('ACTION_JOIN_TO_CAR_MANAGER'))
  },
  ACTION_DELETE_CAR: () => {
    wrapAction(() => wsActions.socket.emit('ACTION_DELETE_CAR'))
  }
}

/**
 *
 * @param {Socket} socket
 */
function bindWsEvents (socket) {
  wsActions.socket = socket

  Object.keys(wsEvents).forEach(eventName => {
    socket.on(eventName, (args) => AuctionEventEmitter.emit(eventName, args))
  })
}

/**
 * Get auctions.
 * @param {object} params - query params
 * @param {number} params.take - maximum number of elements
 * @param {number} params.skip - number of elements to skip
 * @param {string} params.search - search query
 * @returns
*/
const loadAuctions = ({ take, skip, search, all }) => {
  const query = concantQuery({ take, skip, search, all })
  return api.get(`/statistical/auctions${query}`)
}

const loadMarketplaceAuctions = ({ take, skip, search, all }) => {
  const query = concantQuery({ take, skip, search, all })
  return api.get(`/statistical/marketplace-vehicles${query}`)
}

const loadMarketplaceSoldAuctions = ({ take, skip, search, all }) => {
  const query = concantQuery({ take, skip, search, all })
  return api.get(`/statistical/marketplace-sold-vehicles${query}`)
}

const loadTeslaAuctions = ({ take, skip, search, all }) => {
  const query = concantQuery({ take, skip, search, all })
  return api.get(`/tesla/admin-vehicles${query}`)
}

const loadTeslaAuctionById = ({ id }) => {
  return api.get(`/tesla/vehicle/${id}`)
}

const loadAuctionManagerData = ({ take, skip, search, all }) => {
  const query = concantQuery({ take, skip, search, all })
  return api.get(`/statistical/car-auction-management${query}`)
}

/**
 * Add photos to car.
 *
 * @param {FormData} formData
 * @returns {Promise}
 */
 function addPhotoToJoined(formData) {
  return api({
    method: 'post',
    url: `/cars/add-joined-car-photo/`,
    data: formData,
  })
}

/**
 * Add pdf to car.
 *
 * @param {FormData} formData
 * @returns {Promise}
 */
function addPdfToCar(formData) {
  return api({
    method: 'post',
    url: `/cars/add-car-history/`,
    data: formData,
  })
}

function addCarMainImage(formData) {
  return api({
    method: 'post',
    url: `/cars/add-main-image/`,
    data: formData,
  })
}

function setAuctionState({ carId, state, startDate, endDate }) {
  // const query = concantQuery({ state, startDate, endDate })
  let formData = new FormData();
  formData.append("state",state)
  formData.append("startDate",startDate)
  formData.append("endDate",endDate)
  return api({
    method: 'post',
    url: `/cars/set-state/${carId}`,
    data: {state: state, startDate:new Date(startDate), endDate:new Date(endDate)},
  })
}

/* --- PUT --- */
/**
 *
 * @param {object} params
 * @param {number} params.carId
 * @param {FormDate} params.formData
 */
 function putCar({ carId, formData }) {
  return api.put(`/cars/${carId}`, formData)
}


function publishCar({ carId, formData }) {
  return api.put(`/cars/published/${carId}`, formData)
}

/* --- DELETE --- */
/**
 *
 * @param {object} params
 * @param {number} params.id
 * @param {number} params.imageId
 */
 function deleteCarPhoto({ imageId }) {
  return api.delete(`/cars/delete-car-photo/${imageId}`)
}

export {
  loadAuctions,
  addPhotoToJoined,
  putCar,
  deleteCarPhoto,
  setAuctionState,
  bindWsEvents,
  wsActions,
  wsListeners,
  wsEvents,
  addPdfToCar,
  addCarMainImage,
  publishCar,
  loadAuctionManagerData,
  loadMarketplaceAuctions,
  loadMarketplaceSoldAuctions,
  loadTeslaAuctions,
  loadTeslaAuctionById
}
